import { ValidatorFn, Validators } from '@angular/forms';
import { FormField } from '../interfaces/form-field.interface';

export class ValidatorUtils {
  public static generateValidators(control: FormField): ValidatorFn[] {
    const validators: ValidatorFn[] = [];

    if (!control) {
      console.warn('[ValidatorUtils] A falsy value of FormField has been passed');
      return validators;
    }

    if (this.isFormFieldRequired(control)) {
      validators.push(Validators.required);
    }

    if (this.controlValidationEnabled(control)) {
      validators.push(Validators.pattern(control.validation.regExp));
    }

    if (this.controlValidationEnabled(control) && this.isNumberValueDefined(control.validation.minLength)) {
      validators.push(Validators.minLength(control.validation.minLength));
    }

    if (this.controlValidationEnabled(control) && this.isNumberValueDefined(control.validation.maxLength)) {
      validators.push(Validators.maxLength(control.validation.maxLength));
    }

    if (this.controlValidationEnabled(control) && this.isNumberValueDefined(control.validation.min)) {
      validators.push(Validators.min(control.validation.min));
    }

    if (control.validation && control.validation && this.isNumberValueDefined(control.validation.max)) {
      validators.push(Validators.max(control.validation.max));
    }
    return validators;
  }

  public static isFormFieldRequired(control: FormField) {
    return (control.required && (!control.conditions || control.conditions.length == 0)) ||
      (control.requiredIfShown && (control.conditions && control.conditions.length > 0));
  }

  private static controlValidationEnabled(formField: FormField): boolean {
    return formField.validation && formField.validation.enabled;
  }

  private static isNumberValueDefined(numValue: number): boolean {
    return numValue != null && !isNaN(numValue);
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/utils/validator-utils.ts